//Custom components
import StatCard from '../../../UI/Card/StatCard';

const GrantsSpent = ({ count }: { count: number | string }) => {
  return <StatCard title='Grants Spent' stat={`$ ${count}`} />;
};

export default GrantsSpent;
